import {executeParameterCommand} from './commands/parameter.js';
import {
    setResampleMaster,
    setCreatingNewPack
} from 'actions/index.js';
import {freezeInstrument} from 'track/freeze/FreezeInstrument.js';

class EmacsScripting {
    constructor(sequencerEngine) {
        this.sequencerEngine = sequencerEngine;
    }

    run(str) {
        if (str === 'run') {
            return false;
        }

        if (str.indexOf("=") > -1) {
            return executeParameterCommand(this.sequencerEngine, str);
        }

        if (str in this) {
            this[str]();
            return true;
        }

        return false;
    }

    warp() {
        if (this.track) {
            this.track.warp();
            this.sequencerEngine.update();
        }
    }

    gate() {
        if (this.track) {
            this.track.gated = true;
        }
    }

    ungate() {
        if (this.track) {
            this.track.gated = false;
        }
    }

    sampleSynth() {
        this.sequencerEngine.autoResampleMode = true;

        this.sequencerEngine.masterResampler.prepare();
        this.sequencerEngine.store.dispatch(setResampleMaster(true));
    }

    freezeInstrument() {
        freezeInstrument(this.sequencerEngine);
    }

    async makeInstrument() {
        let track = this.sequencerEngine.addSampledInstrumentTrack();

        for (let i in this.sequencerEngine.tracks) {
            let sample = this.sequencerEngine.tracks[i].sample;
            if (sample) {
                await track.instrument.newSample(undefined, sample);
            }
        }
    }

    pack() {
        this.sequencerEngine.dispatch(
            setCreatingNewPack(true));
    }

    get track() {
        return this.sequencerEngine.getSelectedTrack();
    }
}

export default EmacsScripting;
